import { RESIDENCY_DEADLINES } from '../deadlines.js';
import type { IProgram } from '../types.js';

/** Appeal of a refused sponsorship to the Immigration Appeal Division. */
export const IAD_SPONSORSHIP: IProgram = {
  id: 'iad-sponsorship-appeal',
  name: 'Sponsorship appeal (Immigration Appeal Division)',
  short: 'Sponsorship appeal',
  family: 'appeals',
  status: 'active',
  version: '2026-10-04',
  review: 'pending',
  sources: [{ title: 'IRB: Immigration appeals', url: 'https://irb.gc.ca/en/immigration-appeals/Pages/index.aspx', retrieved: '2026-10-04' }],
  questions: [],
  roles: [{ id: 'sponsor', label: 'Sponsor (appellant)', min: 1, max: 1 }, { id: 'principal', label: 'Person sponsored', min: 1, max: 1 }],
  sections: ['Appeal', 'Evidence', 'Hearing'],
  items: [
    { id: 'notice', label: 'Notice of appeal, with the refusal letter', section: 'Appeal', forRoles: 'application', source: 0 },
    { id: 'record', label: 'Appeal record from IRCC (received and reviewed)', section: 'Appeal', forRoles: 'application', source: 0 },
    { id: 'evidence', label: 'Evidence answering the refusal reasons', section: 'Evidence', forRoles: 'application', source: 0, translationIfNotEnFr: true },
    { id: 'disclosure', label: 'Documents disclosed to the IAD and the Minister before the hearing', section: 'Hearing', forRoles: 'application', source: 0 },
    { id: 'witnesses', label: 'Witnesses and hearing preparation', section: 'Hearing', forRoles: 'application', source: 0 }
  ],
  deadlines: []
};

/** Appeal of a residency obligation decision to the Immigration Appeal Division. */
export const IAD_RESIDENCY: IProgram = {
  ...IAD_SPONSORSHIP,
  id: 'iad-residency-appeal',
  name: 'Residency obligation appeal (Immigration Appeal Division)',
  short: 'Residency appeal',
  roles: [{ id: 'principal', label: 'Permanent resident (appellant)', min: 1, max: 1 }],
  items: [
    { id: 'notice', label: 'Notice of appeal, with the decision', section: 'Appeal', forRoles: 'application', source: 0 },
    { id: 'record', label: 'Appeal record from IRCC (received and reviewed)', section: 'Appeal', forRoles: 'application', source: 0 },
    { id: 'presence', label: 'Proof of days in Canada, and the humanitarian reasons', section: 'Evidence', forRoles: ['principal'], source: 0, translationIfNotEnFr: true },
    { id: 'disclosure', label: 'Documents disclosed to the IAD and the Minister before the hearing', section: 'Hearing', forRoles: 'application', source: 0 }
  ],
  deadlines: RESIDENCY_DEADLINES
};

/** Application for leave and for judicial review at the Federal Court. */
export const JUDICIAL_REVIEW: IProgram = {
  id: 'judicial-review',
  name: 'Federal Court: application for leave and for judicial review',
  short: 'Judicial review',
  family: 'appeals',
  status: 'active',
  version: '2026-10-04',
  review: 'pending',
  sources: [{ title: 'Federal Court: How to file an application for leave and for judicial review (immigration)', url: 'https://www.fct-cf.ca/en/pages/representing-yourself/practice-guides/how-to-file-an-application-for-leave-and-for-judicial-review-immigration', retrieved: '2026-10-04' }],
  questions: [],
  roles: [{ id: 'principal', label: 'Applicant', min: 1, max: 1 }],
  sections: ['Filing', 'Record'],
  items: [
    { id: 'application', label: 'Application for leave and for judicial review, filed and served', section: 'Filing', forRoles: 'application', source: 0 },
    { id: 'decision', label: 'The decision and reasons (and GCMS notes, if requested)', section: 'Record', forRoles: 'application', source: 0 },
    { id: 'applicantRecord', label: 'Applicant\'s record: affidavit, exhibits and memorandum of argument', section: 'Record', forRoles: 'application', source: 0, hint: 'The Federal Court requires a declaration if AI generated content in a filed document.' }
  ],
  deadlines: []
};
